import actions from '@/core/store/configuracao/actions'
import mutations from '@/core/store/configuracao/mutations'
import state from '@/core/store/configuracao/state'
import modeloDocumento from '@/core/store/configuracao/modelo-documento'
import tipoModeloDocumento from '@/core/store/configuracao/tipo-modelo-documento'
import fiscais from '@/core/store/configuracao/fiscais'
import revisoes from '@/core/store/configuracao/revisoes'

export default {
	actions,
	mutations,
	state,
	modules: {
		modeloDocumento,
		tipoModeloDocumento,
		fiscais,
		revisoes,
	},
}
